import { CSSResultGroup, html, svg, TemplateResult } from 'lit'
import { customElement, query, state } from 'lit/decorators.js'
import { SelectingPaymentMethodEvent } from 'components/ordering/checkout/events.js'
import { paymentMethodSelectable } from 'components/ordering/checkout/payment-methods/payment-methods.style.js'
import {
  SelectPaymentMethodRequest
} from 'components/ordering/checkout/payment-methods/payment-backend/select-payment-method-api.js'
import {
  CSCPaymentMethod,
  PaymentMethodState
} from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

export type OverrulePaymentMethodData = {
  ident: string
  name: string | null
  description: string | null
}

const overruleIcon = svg`
  <path d="M22.272 0H169.728C182.005 0 192 10.1487 192 22.7209V121.279C192 133.851 182.005 144 169.728 144H22.272C9.9949 144 0 133.851 0 121.279V22.7209C0 10.1487 9.9949 0 22.272 0Z" fill="#0F1041"/>
  <path d="M117.401 58.0394C118.627 58.0394 119.629 59.0464 119.629 60.2772V64.7527H61.6858V60.2772C61.6858 59.0464 62.6887 58.0394 63.9144 58.0394H117.401ZM119.629 73.7038V96.0815C119.629 97.3123 118.627 98.3193 117.401 98.3193H63.9144C62.6887 98.3193 61.6858 97.3123 61.6858 96.0815V73.7038H119.629ZM63.9144 51.3261C58.9976 51.3261 55 55.3401 55 60.2772V96.0815C55 101.019 58.9976 105.033 63.9144 105.033H117.401C122.318 105.033 126.315 101.019 126.315 96.0815V60.2772C126.315 55.3401 122.318 51.3261 117.401 51.3261H63.9144ZM66.143 90.4871C66.143 92.3473 67.6334 93.8438 69.4859 93.8438H76.1717C78.0242 93.8438 79.5146 92.3473 79.5146 90.4871C79.5146 88.627 78.0242 87.1305 76.1717 87.1305H69.4859C67.6334 87.1305 66.143 88.627 66.143 90.4871ZM86.2004 90.4871C86.2004 92.3473 87.6908 93.8438 89.5433 93.8438H98.4577C100.31 93.8438 101.801 92.3473 101.801 90.4871C101.801 88.627 100.31 87.1305 98.4577 87.1305H89.5433C87.6908 87.1305 86.2004 88.627 86.2004 90.4871Z" fill="white"/>
  <path d="M127.085 39C132.002 39 136 43.0141 136 47.9512V83.7559C136 87.9222 133.152 91.431 129.309 92.4248V83.8691C129.31 83.8316 129.314 83.7939 129.314 83.7559V61.3779H129.309V52.4268H129.314V47.9512C129.314 46.7204 128.311 45.7129 127.085 45.7129H73.5986C72.3731 45.7131 71.3701 46.7205 71.3701 47.9512V49.5654H64.6846V47.9512C64.6846 43.0142 68.6819 39.0002 73.5986 39H127.085Z" fill="white"/>
`

@customElement('csc-overrule-payment-method')
export class CSCOverrulePaymentMethod extends CSCPaymentMethod {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodSelectable]

  @state() protected readonly paymentMethodId: string
  @state() protected readonly customDescription: string | null
  @state() protected state: PaymentMethodState

  @state() private readonly name: string

  @query('#start-payment-form')
  private startPaymentForm!: HTMLFormElement

  constructor(data: OverrulePaymentMethodData, state: PaymentMethodState) {
    super()

    this.state = state
    this.paymentMethodId = data.ident
    this.customDescription = data.description
    this.name = data.name ?? ''
  }

  protected override renderPaymentMethodContent = (): TemplateResult => {
    return html`
      <div class="selectable-content">
        <svg width="55" height="41" viewBox="0 0 192 144" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="${this.name}">
          ${overruleIcon}
        </svg>
        <cse-text>${this.name}</cse-text>
        <div hidden>
          <form id="start-payment-form" action="${this.paymentUrlStore.overrule.startPaymentUrl}" method="post">
            <input type="hidden" name="action_review" value="Confirm">
            <input type="hidden" name="payment_method" value="${this.paymentMethodId}">
          </form>
        </div>
      </div>
    `
  }

  protected override selectPaymentMethod = async (): Promise<void> => {
    if (this.state !== 'selectable') { return }

    this.dispatchEvent(new SelectingPaymentMethodEvent(this.paymentMethodId))

    const selectPaymentMethodRequest = new SelectPaymentMethodRequest(
      this.paymentUrlStore.overrule.selectPaymentMethodUrl,
      this.paymentMethodId,
    )

    await this.paymentBackend.selectPaymentMethod(selectPaymentMethodRequest)
    this.windowLocation.reload()
  }

  protected override startPayment = async (): Promise<void> => {
    if (this.state !== 'selected') { return }

    this.startPaymentForm.requestSubmit()
  }
}
